<div class="kabas-login">
  @if (qrScannerVisible) {
    <div>
      <div class="max-w-xl m-i-auto relative">
        <campus-camera
          [showOverlay]="true"
          [isScannerEnabled]="true"
          [showCameraSelect]="true"
          (scanResultReceived)="onScanResultReceived($event)"
          data-cy="qr-scanner"
        ></campus-camera>
        @if (scanError$ | async; as scanError) {
          <div
            class="[ absolute index-overlay error-container p-i-s p-b-2xs corner-s border border-error bottom-0 left-0 right-0 center-content ]"
            data-cy="qr-scanner-error"
          >
            {{ scanError }}
          </div>
        }
      </div>
    </div>
  }
  <div class="[ flex items-center justify-center ]">
    @if (role === 'student') {
      <kabas-login-student
        [success]="success"
        [error]="error"
        [qrScannerVisible]="qrScannerVisible"
        [classGroups]="classGroups$ | async"
        (schoolCode)="schoolCodeSet($event)"
        (submitForm)="login($event)"
        (ssoLoginClicked)="ssoLogin($event)"
        (afterSuccess)="goToPlatform()"
        (forgetPerson)="forgetPerson($event)"
        (showQrScanner)="showQrScanner($event)"
        [persistedUsers]="persistedUsers$ | async"
        data-cy="modal-login-student"
      ></kabas-login-student>
    }

    @if (role === 'teacher' || role === 'schooladmin') {
      <kabas-login-teacher
        (submitForm)="login($event)"
        (ssoLoginClicked)="ssoLogin($event)"
        [success]="success"
        [error]="error"
        (afterSuccess)="goToPlatform()"
        (forgotPassword)="resetPassword($event)"
        [role]="role"
        data-cy="modal-login-teacher"
      ></kabas-login-teacher>
    }
  </div>
</div>
